import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { BiSliderAlt } from "react-icons/bi";
import useUser from "hooks/use-user";
import "./multiSelect.css";
import LoadingComponent from "components/Main/Loading";
import Select from "react-select";
import { decrypt } from "helpers/decrypt";

interface AddUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: any;
}

const UpdateUserModal: React.FC<AddUserModalProps> = ({
  isOpen,
  onClose,
  id,
}) => {
  const {
    getSuppliers,
    suppliers,
    putData,
    dataUpdate,
    dataUpdateSuppliers,
    loadingGeneratePassword,
    generatePassword,
  } = useUser();
  const toast = useToast();
  const [isOpenPopov, setIsOpenPopov] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
    accessScheduling: true,
    accessPortal: true,
    suppliersId: "",
    displayNameCalendar: false,
  });

  const [isFirstRender, setFirstRender] = useState(false);
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(true);
  const [selectSupplier, setSelectSupplier] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const textTable = useColorModeValue("black", "white");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const optionsSystem = [
    { label: "  1 - Portal", value: 1 },
    { label: "  2 - Logistica", value: 2 },
  ];
  const customStyles = {
    option: (provided: any, state: { isSelected: any }) => ({
      ...provided,
      borderBottom: "1px dotted pink",
      color: state.isSelected ? "black" : "black",
      padding: 20,
    }),
  };
  const handleDinamico = (e: {
    target: { name: any; value: any; type: any; checked: any };
  }) => {
    const { name, value, type, checked } = e.target;

    setUserData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = () => {
    if (!validateEmail(userData.email)) {
      toast({
        title: "Error",
        description: "Formato do email incorreto",
        status: "warning",
        position: "top",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    var accessportal = selectedOptions.findIndex((x) => x.value === 1);
    var accesspscheduling = selectedOptions.findIndex((x) => x.value === 2);
    const idsSuppliers = selectSupplier.map((objeto) => objeto.value);
    const objUser = {
      name: userData.name,
      email: userData.email,
      accessScheduling: accessportal !== -1 ? true : false,
      accessPortal: accesspscheduling !== -1 ? true : false,
      suppliersIds: idsSuppliers,
      displayNameCalendar: userData.displayNameCalendar === true ? true : false,
    };
    putData(objUser, dataUpdate.id);
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      setSelectSupplier([]);
      setIsLoadingSuppliers(true);
      if (suppliers.length === 0) {
        getSuppliers();
      }
    }
  }, [isOpen]);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  let map: any = [];

  useEffect(() => {
    if (dataUpdate != null && isOpen && suppliers.length > 0) {
      setSelectSupplier([]);

      setFirstRender(true);
      let selectOptions = [];
      if (dataUpdate.accessScheduling) {
        selectOptions.push({ label: "  1 - Portal", value: 1 });
      }

      if (dataUpdate.accessPortal) {
        selectOptions.push({ label: "  1 - Logistica", value: 2 });
      }
      setSelectedOptions(selectOptions);
      setUserData({
        name: dataUpdate.name,
        email: dataUpdate.email,
        password: decrypt(dataUpdate.password, true),
        accessScheduling: dataUpdate.accessScheduling,
        accessPortal: dataUpdate.accessPortal,
        suppliersId: dataUpdateSuppliers[0]?.supplierId,
        displayNameCalendar: dataUpdate.displayNameCalendar,
      });
      dataUpdateSuppliers.map((item: any) => {
        let filter = suppliers.filter(
          (sup: any) => sup.value === item.supplierId
        )[0];
        map.push(filter);
      });
      setSelectSupplier((prevSelectSupplier) => {
        let map: any = [];
        dataUpdateSuppliers.map((item: any) => {
          let filter = suppliers.filter(
            (sup: any) => sup.value === item.supplierId
          )[0];
          map.push(filter);
        });
        return map;
      });
      setTimeout(() => {
        setIsLoadingSuppliers(false);
      }, 900);
    }
    //  if (
    //    dataUpdate != null &&
    //    dataUpdateSuppliers.length > 0 &&
    //    isOpen &&
    //    suppliers.length > 0
    //  ) {
    //    setSelectSupplier([]);

    //    setFirstRender(true);
    //    let selectOptions = [];
    //    if (dataUpdate.accessScheduling) {
    //      selectOptions.push({ label: "  1 - Portal", value: 1 });
    //    }

    //    if (dataUpdate.accessPortal) {
    //      selectOptions.push({ label: "  1 - Logistica", value: 2 });
    //    }
    //    setSelectedOptions(selectOptions);
    
    //    setUserData({
    //      name: dataUpdate.name,
    //      email: dataUpdate.email,
    //      password: decrypt(dataUpdate.password, true),
    //      accessScheduling: dataUpdate.accessScheduling,
    //      accessPortal: dataUpdate.accessPortal,
    //      suppliersId: dataUpdateSuppliers[0]?.supplierId,
    //    });
    //    dataUpdateSuppliers.map((item: any) => {
    //      let filter = suppliers.filter(
    //        (sup: any) => sup.value === item.supplierId
    //      )[0];
    //      map.push(filter);
    //    });
    //    setSelectSupplier((prevSelectSupplier) => {
    //      let map: any = [];
    //      dataUpdateSuppliers.map((item: any) => {
    //        let filter = suppliers.filter(
    //          (sup: any) => sup.value === item.supplierId
    //        )[0];
    //        map.push(filter);
    //      });
    //      return map;
    //    });
    //    setTimeout(() => {
    //      setIsLoadingSuppliers(false);
    //    }, 900);
    //  }
  }, [
    dataUpdate,
    setSelectSupplier,
    dataUpdateSuppliers,
    setIsLoadingSuppliers,
    setSelectedOptions,
    suppliers,
    suppliers.length,
  ]);

  const handleToggleSenha = () => {
    setMostrarSenha(!mostrarSenha);
  };

  const handleCopyPassword = () => {
    navigator.clipboard.writeText(userData.password);
  };

  const handleClose = () => {
    setUserData({
      name: "",
      email: "",
      password: "",
      accessScheduling: true,
      accessPortal: true,
      suppliersId: "",
      displayNameCalendar: false,
    });
    setSelectSupplier([]);

    setMostrarSenha(false);
    onClose();
  };

  const handleOpen = () => {
    setIsOpenPopov(true);
  };

  const handleClosePopov = () => {
    setIsOpenPopov(false);
  };

  const handleGerarSenha = async () => {
    handleClosePopov();
    try {
      const password = await generatePassword(id);

      if (password !== "") {
        setUserData((prevUserData) => ({
          ...prevUserData,
          password: decrypt(password, true),
        }));
      }
    } catch (error) {
      console.error("Erro ao gerar senha:", error);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={"gray.200"}
            background={"#1d5840"}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                Editar Usuário
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody>
            {isLoadingSuppliers ? (
              <>
                <LoadingComponent spinnerSize="30vh" />
              </>
            ) : (
              <>
                <Box maxW={480} flex={{ base: "1", md: "0 0 300px" }} pb={6}>
                  <Flex>
                    <Box pl={2} pr={2}>
                      <FormLabel fontWeight={700}>Nome</FormLabel>
                      <Input
                        type="text"
                        w={{ base: 330, md: 440 }}
                        name="name"
                        value={userData.name}
                        onChange={handleDinamico}
                        color={textTable}
                      />
                    </Box>
                  </Flex>
                  <Flex>
                    <Box pl={2} pr={2} pt={4}>
                      <FormLabel fontWeight={700}>Email</FormLabel>
                      <Input
                        type="text"
                        w={{ base: 330, md: 440 }}
                        name="email"
                        value={userData.email}
                        onChange={handleDinamico}
                        color={textTable}
                      />
                    </Box>
                  </Flex>
                  {/* <Flex>
                    <Box
                      pl={2}
                      pr={2}
                      pt={4}
                      display="flex"
                      alignItems="center"
                    >
                      <FormLabel fontWeight={700} mr={2} mt={3}>
                        Senha
                      </FormLabel>

                      <Popover isOpen={isOpenPopov} onClose={handleClosePopov}>
                        <PopoverTrigger>
                          <Button
                            bg="#1d5840"
                            color="white"
                            ml={2}
                            h="16px"
                            pb={4}
                            fontSize={10}
                            p="10px 10px"
                            onClick={handleOpen}
                          >
                            Gerar Senha
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent>
                          <PopoverArrow />
                          <PopoverCloseButton />
                          <PopoverHeader>Gerar nova Senha!</PopoverHeader>
                          <PopoverBody>
                            Desejar realmente gerar uma nova senha, essa acao
                            nao pode ser desfeita
                          </PopoverBody>
                          <PopoverFooter
                            border="0"
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            pb={4}
                          >
                            <Button
                              background="green.300"
                              color="white"
                              onClick={() => {
                                handleGerarSenha();
                              }}
                              style={{ marginLeft: "auto" }}
                            >
                              Gerar
                            </Button>
                          </PopoverFooter>
                        </PopoverContent>
                      </Popover>
                    </Box>
                  </Flex>

                  <Flex>
                    <Box pl={2} pr={2} pt={4}>
                      <InputGroup>
                        {loadingGeneratePassword ? (
                          <Spinner
                            size="sm"
                            position="absolute"
                            right="-2rem"
                            top="50%"
                            transform="translateY(-50%)"
                          />
                        ) : (
                          <>
                            <Input
                              type={mostrarSenha ? "text" : "password"}
                              color={textTable}
                              w={{ base: 330, md: 440 }}
                              name="password"
                              isDisabled={true}
                              value={userData.password}
                              onChange={handleDinamico}
                            />
                            <InputRightElement width="3rem" mr={5}>
                              <Button
                                bg="white"
                                _hover={{ bg: "white" }} // Definindo as propriedades de hover padrão
                                onClick={handleToggleSenha}
                                h="100%"
                              >
                                {mostrarSenha ? (
                                  <FaRegEye />
                                ) : (
                                  <FaRegEyeSlash />
                                )}
                              </Button>
                              <Button
                                onClick={handleCopyPassword}
                                bg="white"
                                ml={2}
                                _hover={{ bg: "white" }} // Definindo as propriedades de hover padrão
                                h="100%"
                              >
                                <FaCopy />
                              </Button>
                            </InputRightElement>
                          </>
                        )}
                      </InputGroup>
                    </Box>
                  </Flex> */}
                </Box>
                <Box maxW={480} pb={6}>
                  <Flex direction={{ base: "column", md: "row" }}>
                    <Box pl={2} pr={2} mb={{ base: 4, md: 0 }}>
                      {isFirstRender && (
                        <>
                          <Select
                            defaultValue={selectSupplier}
                            name="colors"
                            onChange={setSelectSupplier}
                            options={suppliers}
                            loading={isLoadingSuppliers}
                            placeholder="Selecione os fornecedores..."
                            theme={(theme: { colors: any }) => ({
                              ...theme,
                              borderRadius: 0,
                              colors: {
                                ...theme.colors,
                                text: "#6EB680",
                                font: "#6EB680",
                                primary25: "#6EB680",
                                primary: "#6EB680",
                                neutral80: "black",
                                color: "black",
                              },
                            })}
                            styles={customStyles}
                            isMulti
                            className="custom-select-2"
                            classNamePrefix="select"
                          />
                        </>
                      )}
                    </Box>
                  </Flex>
                  <Stack direction="row" align="center" mt={2} ml={2}>
                    <Checkbox
                      name="displayNameCalendar"
                      isChecked={userData.displayNameCalendar}
                      onChange={(e) =>
                        handleDinamico({
                          target: {
                            name: "displayNameCalendar",
                            value: e.target.value,
                            type: "checkbox",
                            checked: e.target.checked,
                          },
                        })
                      }
                    >
                      Adicionar usuário ao calendário
                    </Checkbox>
                  </Stack>
                </Box>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Fechar
            </Button>
            <Button
              colorScheme="green"
              ml={3}
              isDisabled={userData.name === "" || userData.email === ""}
              onClick={handleSubmit}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UpdateUserModal;
